import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'shared/components';
import { FormattedMessage } from 'react-intl';

import theme from 'modules/queues/Schedule/containers/VideoSidebarLayout/VideoSidebar/VideoSidebar.scss';


const propTypes = {
  removeSlowInternetToast: PropTypes.func.isRequired,
  isNeedToShowToast: PropTypes.bool.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

const InternetMeterToastPlace = ({ removeSlowInternetToast, isNeedToShowToast }) => {
  if (!isNeedToShowToast) return <div />;

  return (
    <div className={ theme.internetMeterToastPlace }>
      <Icon name="slow_connection" className={ theme.icon } />
      <div className={ theme.message }>
        <FormattedMessage
          id="SlowInternetBar.FirstLine"
          defaultMessage="** Internet connection is slow. Video quality may be affected"
        />
      </div>
      <div className={ theme.dismiss } onClick={ removeSlowInternetToast }>
        <FormattedMessage
          id="Appointments.CancelAppointment.CancellationReasonsDialog.Dismiss.Button"
          defaultMessage="** Dismiss"
        />
      </div>
    </div>
  );
};

InternetMeterToastPlace.propTypes = propTypes;

export default InternetMeterToastPlace;
